import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './/app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './auth-guard/auth.guard';
import { OktaInterceptor } from './helpers/okta.interceptor';
import { ClickOutsideModule } from 'ng-click-outside';

//Environment
import { environment } from "../environments/environment";

//Okta Components
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';

const config = {
  issuer: environment.issuer,
  redirectUri: environment.redirectUri,
  clientId: environment.clientId,
  scopes: ['openid', 'profile', 'email']
};

//App Components
import { AppMainComponent } from './app.maincomponent';
import { LoginComponent } from './login-form/app.logincomponent';
import { PraMainComponent } from './pra-main/pra-main.component';
import { PraNewRequestComponent } from './pra-new-request/pra-new-request.component';
import { PraConfirmRequestComponent } from './pra-confirm-request/pra-confirm-request.component';
import { PraNotAuthorizedComponent } from './pra-not-authorized/pra-not-authorized.component';
import { PraSearchRequestsComponent } from './pra-search-requests/pra-search-requests.component';
import { ChildRequestGridComponent } from './pra-search-requests/child-request-grid/child-request-grid.component';
import { PraDetailsComponent } from './pra-details/pra-details.component';
import { PraSearchByEidComponent } from './pra-search-by-eid/pra-search-by-eid.component';
import { ChildSearchByEidComponent } from './pra-search-by-eid/child-request-grid/child-request-grid.component';
import { PraAdminEditComponent } from './pra-admin-edit/pra-admin-edit.component';

//Services
import { AuthenticationService } from './services/authentication.service';
import { PraService } from './services/pra.service';
import { FormatDataService } from './services/format-data.service';
import { NavUserAccessService } from './services/nav-user-access.service';

// UI Components
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';
import { AgGridModule } from 'ag-grid-angular';
import { NgxLoadingModule } from 'ngx-loading';
import { SidebarModule } from 'ng-sidebar';
import { MomentModule } from 'ngx-moment';

//Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';


// Add an icon to the library for convenient access in other components
library.add(faBars);
library.add(faHome);
library.add(faPen);
library.add(faWindowClose);
library.add(faSignOutAlt);
library.add(faQuestionCircle);
library.add(faCheckCircle);
library.add(faSearch);
library.add(faPlusCircle);
library.add(faMinusCircle);
library.add(faFileExcel);
library.add(faTrash);
library.add(faTimes);


@NgModule({
  declarations: [
    AppMainComponent,
    LoginComponent,
    PraMainComponent,
    PraNewRequestComponent,
    PraConfirmRequestComponent,
    PraNotAuthorizedComponent,
    PraSearchRequestsComponent,
    ChildRequestGridComponent,
    PraDetailsComponent,
    PraSearchByEidComponent,
    ChildSearchByEidComponent,
    PraAdminEditComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule.forRoot(),
    SidebarModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    AppRoutingModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MomentModule,
    ClickOutsideModule,
    OktaAuthModule,
    NgxMaskModule.forRoot(),
    Ng2DeviceDetectorModule.forRoot(),
    AgGridModule.withComponents([ChildRequestGridComponent, ChildSearchByEidComponent])
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    FormatDataService,
    NavUserAccessService,
    PraService,
    { provide: OKTA_CONFIG, useValue: config },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OktaInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppMainComponent]
})
export class AppModule { }
